module.exports = __webpack_public_path__ + "img/event_1080x540.4068709e.png";